import { useState } from "react";
import { WeeklyBreakdownCard } from "./breakdown/WeeklyBreakdownCard";
import { MonthlyBreakdownCard } from "./breakdown/MonthlyBreakdownCard";
import { QuarterlyBreakdownCard } from "./breakdown/QuarterlyBreakdownCard";
import { BiannuallyBreakdownCard } from "./breakdown/BiannuallyBreakdownCard";
import { YearlyBreakdownCard } from "./breakdown/YearlyBreakdownCard";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { cn } from "@/lib/utils";

type RecurrenceType = 'all' | 'weekly' | 'monthly' | 'quarterly' | 'biannually' | 'yearly';

export function RecurrenceBreakdownView() {
  const [selectedRecurrence, setSelectedRecurrence] = useState<RecurrenceType>('all');
  const [searchQuery, setSearchQuery] = useState('');

  const handleRecurrenceClick = (type: RecurrenceType) => {
    setSelectedRecurrence(selectedRecurrence === type ? 'all' : type);
  };

  const recurrenceButtons: { type: RecurrenceType; label: string }[] = [
    { type: 'weekly', label: 'Weekly' },
    { type: 'monthly', label: 'Monthly' },
    { type: 'quarterly', label: 'Quarterly' },
    { type: 'biannually', label: 'Biannual' },
    { type: 'yearly', label: 'Yearly' },
  ];

  return (
    <div className="space-y-6">
      {/* Filter Bar */}
      <div className="flex items-center gap-4 flex-wrap">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium">Focus:</span>
          {recurrenceButtons.map(({ type, label }) => (
            <Button
              key={type}
              variant="outline"
              size="sm"
              onClick={() => handleRecurrenceClick(type)}
              className={cn(
                "h-8",
                selectedRecurrence === type && "bg-yellow-100 border-yellow-300 hover:bg-yellow-200"
              )}
            >
              {label}
            </Button>
          ))}
        </div>
        
        <div className="flex-1 max-w-xs">
          <div className="relative">
            <Search className="absolute left-2 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input
              type="text"
              placeholder="Search tasks..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="h-8 pl-8"
            />
          </div>
        </div>
      </div>

      {/* Breakdown Cards */}
      {(selectedRecurrence === 'all' || selectedRecurrence === 'weekly') && (
        <WeeklyBreakdownCard searchQuery={searchQuery} />
      )}
      {(selectedRecurrence === 'all' || selectedRecurrence === 'monthly') && (
        <MonthlyBreakdownCard searchQuery={searchQuery} />
      )}
      {(selectedRecurrence === 'all' || selectedRecurrence === 'quarterly') && (
        <QuarterlyBreakdownCard searchQuery={searchQuery} />
      )}
      {(selectedRecurrence === 'all' || selectedRecurrence === 'biannually') && (
        <BiannuallyBreakdownCard searchQuery={searchQuery} />
      )}
      {(selectedRecurrence === 'all' || selectedRecurrence === 'yearly') && (
        <YearlyBreakdownCard searchQuery={searchQuery} />
      )}
    </div>
  );
}